import { render, staticRenderFns } from "./GoalOption.vue?vue&type=template&id=17e77739&scoped=true&"
import script from "./GoalOption.vue?vue&type=script&lang=js&"
export * from "./GoalOption.vue?vue&type=script&lang=js&"
import style0 from "./GoalOption.vue?vue&type=style&index=0&id=17e77739&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e77739",
  null
  
)

export default component.exports